// src/composite/composite-context.ts
import { createContext } from "react";
var CompositeItemContext = createContext(
  void 0
);
var CompositeRowContext = createContext(
  void 0
);
var CompositeContext = createContext(
  void 0
);

export {
  CompositeItemContext,
  CompositeRowContext,
  CompositeContext
};
